/* eslint-disable */
// GENERATED by scripts/build-content.mjs — do not edit. Run `npm run build:content`.
import type { ContentMeta } from './registry'

export interface ManifestEntry {
  collection: string
  slug: string
  path: string
  meta: ContentMeta
}

export const manifest: ManifestEntry[] = [
  {
    "collection": "guides",
    "slug": "cleaning-business-invoicing",
    "path": "/guides/cleaning-business-invoicing",
    "meta": {
      "title": "Invoicing for cleaning businesses",
      "description": "How to invoice cleaning clients so you actually get paid. Deposits, payment terms, card versus ACH costs, and what to do when an invoice goes unpaid.",
      "summary": "Getting paid is the part that decides whether the business works. Here is how to make it boring.",
      "updated": "2026-07-29",
      "navLabel": "Invoicing",
      "targetQuery": "how to invoice for cleaning services"
    }
  },
  {
    "collection": "guides",
    "slug": "get-more-cleaning-clients",
    "path": "/guides/get-more-cleaning-clients",
    "meta": {
      "title": "How to get more cleaning clients",
      "description": "Where residential cleaning clients actually come from, ranked by what works for a small business, with specific tactics for Google Business Profile, referrals and local groups.",
      "summary": "Ranked by what actually works for a small cleaning business, not by what is easiest to write about.",
      "updated": "2026-07-29",
      "navLabel": "Getting clients",
      "targetQuery": "how to get more cleaning clients"
    }
  },
  {
    "collection": "guides",
    "slug": "how-to-price-house-cleaning",
    "path": "/guides/how-to-price-house-cleaning",
    "meta": {
      "title": "How to price a house cleaning job",
      "description": "A working method for pricing residential cleaning. Build your rate from labour, overhead and profit rather than guessing, with worked examples for recurring cleans, deep cleans and move-outs.",
      "summary": "Most cleaners price by looking at competitors and shaving a bit off. Here's how to build a number that actually pays you.",
      "updated": "2026-07-29",
      "navLabel": "Pricing a clean",
      "targetQuery": "how to price a house cleaning job"
    }
  },
  {
    "collection": "guides",
    "slug": "recurring-cleaning-schedules",
    "path": "/guides/recurring-cleaning-schedules",
    "meta": {
      "title": "Setting up recurring cleaning schedules",
      "description": "How to structure weekly, biweekly and monthly cleaning schedules so the calendar builds itself, routes stay tight, and holidays and cancellations do not cascade.",
      "summary": "Recurring work is most of your revenue. The schedule should build itself, not get rebuilt every Sunday.",
      "updated": "2026-07-29",
      "navLabel": "Recurring schedules",
      "targetQuery": "recurring cleaning schedule for clients"
    }
  },
  {
    "collection": "compare",
    "slug": "housecall-pro-alternative-cleaning",
    "path": "/compare/housecall-pro-alternative-cleaning",
    "meta": {
      "title": "A Housecall Pro alternative for cleaning businesses",
      "description": "Housecall Pro is built for home-service trades and priced for them. CleanDock covers five users for $49.99/mo. An honest pricing and feature comparison for cleaning businesses.",
      "summary": "Housecall Pro is a big, capable product priced for trades with office staff. Here's what that costs a cleaning crew, and where each tool actually fits.",
      "updated": "2026-07-27",
      "targetQuery": "housecall pro alternative"
    }
  },
  {
    "collection": "compare",
    "slug": "jobber-alternative-cleaning",
    "path": "/compare/jobber-alternative-cleaning",
    "meta": {
      "title": "A Jobber alternative built for cleaning businesses",
      "description": "Jobber is built for trades. CleanDock is built for cleaning businesses. Recurring cleans, online booking, before/after photos, and 5 users for $49.99/mo. An honest pricing and feature comparison.",
      "summary": "Jobber is good software that wasn't built for cleaning. Here's an honest comparison of what each costs and where each one actually fits.",
      "updated": "2026-07-27",
      "targetQuery": "jobber alternative for cleaning business"
    }
  },
  {
    "collection": "compare",
    "slug": "launch27-automaid-alternative",
    "path": "/compare/launch27-automaid-alternative",
    "meta": {
      "title": "Launch27 became Automaid. Here's an alternative if that's not the direction you wanted",
      "description": "Launch27 rebranded to Automaid under Fullsteam in May 2026. If the new direction isn't for you, CleanDock covers quoting, recurring cleans, online booking and payments from $29.99/mo.",
      "summary": "Launch27 is now Automaid. If your booking software changing hands and direction has you looking around, here's what to weigh.",
      "updated": "2026-07-27",
      "targetQuery": "launch27 alternative"
    }
  },
  {
    "collection": "solutions",
    "slug": "airbnb-turnover-cleaning-software",
    "path": "/airbnb-turnover-cleaning-software",
    "meta": {
      "title": "Airbnb turnover cleaning software",
      "description": "Software for Airbnb and short-term rental turnovers. Same-day scheduling, before/after photo proof on every clean, and card or ACH payment. From $29.99/mo, five users for $49.99.",
      "summary": "Same-day turnarounds, hard checkout windows, and hosts who want proof the unit was ready.",
      "updated": "2026-07-27",
      "navLabel": "Airbnb turnovers",
      "targetQuery": "airbnb turnover cleaning software"
    }
  },
  {
    "collection": "solutions",
    "slug": "commercial-janitorial-software",
    "path": "/commercial-janitorial-software",
    "meta": {
      "title": "Commercial and janitorial cleaning software",
      "description": "Software for small commercial and janitorial crews. Recurring contract schedules, crew time tracking, employee-pay reports, and card or ACH invoicing. Unlimited users for $99.99/mo.",
      "summary": "Recurring contract schedules, crew time tracking, and invoicing built for small commercial crews.",
      "updated": "2026-07-27",
      "navLabel": "Commercial & janitorial",
      "targetQuery": "janitorial software for small business"
    }
  },
  {
    "collection": "solutions",
    "slug": "maid-service-software",
    "path": "/maid-service-software",
    "meta": {
      "title": "Maid service software",
      "description": "Software for residential maid services. Recurring cleans that repeat themselves, online booking, before/after photos, and card or ACH payment. From $29.99/mo, five users for $49.99.",
      "summary": "Recurring clients are most of your revenue. The schedule should build itself.",
      "updated": "2026-07-27",
      "navLabel": "Maid services",
      "targetQuery": "maid service software"
    }
  },
  {
    "collection": "solutions",
    "slug": "move-out-cleaning-software",
    "path": "/move-out-cleaning-software",
    "meta": {
      "title": "Move-out cleaning software",
      "description": "Software for move-out and turnover cleaning. Fast quoting, before/after photo evidence for deposit disputes, and card or ACH payment. From $29.99/mo, five users for $49.99.",
      "summary": "One-off, high-ticket jobs where the quote has to go out fast and the photos have to hold up.",
      "updated": "2026-07-27",
      "navLabel": "Move-out cleaning",
      "targetQuery": "move out cleaning business software"
    }
  },
  {
    "collection": "solutions",
    "slug": "solo-house-cleaner-software",
    "path": "/solo-house-cleaner-software",
    "meta": {
      "title": "Software for solo house cleaners",
      "description": "$29.99/mo software for independent house cleaners. Recurring schedules, online booking, before/after photos, and card or ACH payment. No per-user fees, no annual contract.",
      "summary": "Real software for one person, at a price that makes sense when you are the whole business.",
      "updated": "2026-07-27",
      "navLabel": "Solo cleaners",
      "targetQuery": "app for independent house cleaners"
    }
  }
]
